import { drawBay } from "./panelsManagment";
import { PanelsContainer } from "__editor/panelsEditor/models/panelsContainer";

export const createBays = (
  panelBaysMapping: panelBayMapping = new Map(),
  panelsDict,
  baysContainer: PanelsContainer,
  visitedBays: number[],
  rightEdgePanels: number[],
  leftEdgePanels: number[],
  northEdgePanels: number[],
  northRightEdgePanels: number[],
  northMostRow: number[],
  forceRedrawBayIds: Set<number> = new Set(),
) => {
  const expectedBaysById = new Map<number, { attached: 0 | 1; bay: { attached: 0 | 1; id: number; p: number }; panelId: number }>();

  panelBaysMapping.forEach((baysAssociated, panelId) => {
    baysAssociated?.forEach((bay) => {
      if (!expectedBaysById.has(bay.id)) {
        expectedBaysById.set(bay.id, { attached: bay.attached, bay, panelId });
      }
    });
  });

  const updatedBays = new Set<number>();
  const nextChildren = [];

  [...baysContainer.children].forEach((child: any) => {
    const expectedBay = expectedBaysById.get(child.id);

    if (!expectedBay || forceRedrawBayIds.has(child.id) || child.attached !== expectedBay.attached) {
      child.destroy({ children: true });
      return;
    }

    updatedBays.add(child.id);
    nextChildren.push(child);
  });

  baysContainer.children = nextChildren;

  if (panelBaysMapping && Object.keys(panelsDict).length >= 1) {
    expectedBaysById.forEach(({ bay, panelId }, bayId) => {
      if (updatedBays.has(bayId) || !panelsDict[panelId]) {
        return;
      }

      const pixiPanel: PIXI.Graphics = drawBay(
        panelsDict[panelId],
        bay,
        rightEdgePanels,
        leftEdgePanels,
        northEdgePanels,
        northRightEdgePanels,
        northMostRow,
      );

      baysContainer.addChild(pixiPanel);
      updatedBays.add(bayId);
    });
  }

  return Array.from(updatedBays);
};
